import SterilizerProvisory from './SterilizerProvisory';

export default SterilizerProvisory;